import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "@/components/atoms/Breadcrumb";
import { Fragment } from "react/jsx-runtime";

const StandardBreadcrumb = ({
  items,
}: {
  items: { label: string; href?: string; onClick?: () => void }[];
}) => (
  <Breadcrumb>
    <BreadcrumbList>
      <BreadcrumbItem>
        <BreadcrumbLink href="/">Home</BreadcrumbLink>
      </BreadcrumbItem>
      <BreadcrumbSeparator />
      {items?.map((item, index) => (
        <Fragment key={index}>
          <BreadcrumbItem>
            <BreadcrumbLink
              href={item.href}
              onClick={item.onClick}
              className={item.onClick && "cursor-pointer"}
            >
              {item.label}
            </BreadcrumbLink>
          </BreadcrumbItem>
          {index < items.length - 1 && <BreadcrumbSeparator />}
        </Fragment>
      ))}
    </BreadcrumbList>
  </Breadcrumb>
);

export default StandardBreadcrumb;
